import React, { useContext } from 'react'
import { WidgetState } from './api'
import { DashboardContext } from 'live/context/dashboard'
import LiveUtils from 'live/lib/utils'
import MapWidget from './MapWidget'
import { reactWidgetWrapper } from 'live/widgets/decorators/react'
import widgetService from 'live/services/widgets'
import { mapWidgetReducer } from './MapWidget/mapWidgetReducer'

function MapsWidget({
    state,
    width,
    height
}: {
    state: WidgetState
    width: number
    height: number
}): React.ReactElement {
    const { theme } = useContext(DashboardContext)


    return state.batch.length ? (
        <MapWidget
            dashTheme={theme}
            batch={state.batch}
            meta={state.meta}
            height={height}
            width={width}
            isMobile={LiveUtils.isMobile()}
        />
    ) : null
}

MapsWidget.policies = {
    defaultReducer: '@latest'
}

const widgetImpl = reactWidgetWrapper(MapsWidget, mapWidgetReducer)

widgetService.register({
    name: 'Assets Map',
    type: 'assets-map',
    config: {},
    policies: {
        layers: 1
    },
    description: 'Map widget with markers dedicated to assets',
    impl: widgetImpl
})
